import axios from 'axios';
// import qs from 'qs';

export default {
  parse(data) {
    return axios.post('/v1/io/parse', data, {
      params: {
        profileId: localStorage.getItem('profile_id')
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  parseSales(data) {
    return axios.post('/v1/io/parse-sales', data, {
      params: {
        profileId: localStorage.getItem('profile_id')
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  uploadDocs(data) {
    return axios.post('/v1/io/upload_docs', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  create(data) {
    return axios.post('/v1/io/spending', data);
  },
  edit(data) {
    return axios.post('/v1/io/edit', data);
  },
  getGuideline() {
    return axios.get('/v1/io/guidlines');
  },
  approve(data) {
    return axios.post('/v1/io/approve', data);
  },
  approveBO(data) {
    return axios.post('/v1/io/approveByBudgetOwner', data);
  },
  approveHouse(data) {
    return axios.post('/v1/io/approve-house', data);
  },
  reject(data) {
    return axios.post('/v1/io/reject', data);
  },
  rejectBO(data) {
    return axios.post('/v1/io/rejectByBudgetOwner', data);
  },
  rejectHouse(data) {
    return axios.post('/v1/io/reject-per-house', data);
  },
  submit(data) {
    return axios.post('/v1/io/submit', data);
  },
  detail(params = {}) {
    return axios.get('/v1/io/detail', { params });
  },
  getProduct(params = {}) {
    return axios.get('/v1/product/brand', { params });
  },
  editSupportDocs(params = {}) {
    return axios.get('/v1/io/support_docs', { params });
  },
  notesBO(id, data) {
    return axios.put(`/v1/io/edit_notes_bo/${id}`, data);
  },
  notesHouse(id, data) {
    return axios.put(`/v1/io/edit-notes-house/${id}`, data);
  },
  getIO(params = {}) {
    return axios.get('/v1/io/report/detail/spending', { params });
  },
  uploadSAP(data) {
    return axios.post('/v2/integration/upload/sap', data);
  },
  uploadPoBi(data) {
    return axios.post('/v1/purchasing-orders/upload', data);
  },
  uploadIoBi(data) {
    return axios.post('/v1/io/upload/bi', data);
  },
  uploadNonPo(data) {
    return axios.post('/v1/non-purchasing-orders/upload', data);
  },
  advanceFilter(params = {}) {
    return axios.get(`/v1/io/report`, {
      params
      // paramsSerializer: params => {
      //   return qs.stringify(params);
      // }
    });
  },
  approveBOAdhoc(data) {
    return axios.post('/v1/io/approve-adhoc-bo', data);
  },
  approveAdhoc(data) {
    return axios.post('/v1/io/approve-adhoc', data);
  },
  detailProfile({ id }) {
    return axios.get(`/v1/profile/detail-view/${id}`);
  },
  addIO(params = {}) {
    return axios.get('/v1/io/add-adhoc-io', { params });
  },
  detailTaxo(params = {}) {
    return axios.get('/v1/detail-taxo', { params });
  },
  summaryAmount(params = {}) {
    return axios.get('/v1/io/summary', { params });
  },
  getConsolidatedReport(params = {}) {
    return axios.get('/v1/io/report/filter', { params });
  },
  getDetailSpending(params = {}) {
    return axios.get('/v1/io/report/detail', {
      params
    });
  },
  parseRevise(data, params) {
    return axios.post('/v1/io/parse-revise', data, {
      params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  parseReviseSales(data, params) {
    return axios.post('/v1/io/parse-revise-sales', data, {
      params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  createRevise(data) {
    return axios.post('/v1/io/revise', data);
  },
  cancelIO(data) {
    return axios.put('/v1/io/cancel', data);
  },
  uncancelIO(data) {
    return axios.put('/v1/io/uncancel', data);
  },
  getProgressTracking(params = {}) {
    return axios.get('/v2/report/detail/track', { params });
  }
};
